// extracted by mini-css-extract-plugin
export default {"container":"input_container__kxVky"};